const SHOPIFY_ROOT = window.Shopify?.routes?.root || "/";

/* ============================================================
   1) FETCH OVERRIDE + UNKNOWN-SIZE LIMIT
   ============================================================ */

(function () {
  const originalFetch = window.fetch;
  const UNKNOWN_LABEL = "i don't know my ring size";

  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : input.url || "";
    const isAdd = url.includes("/cart/add.js");

    if (isAdd) {
      console.log("🟥 RAW ADD REQUEST:", init?.body);
      try { console.log("parsed:", JSON.parse(init.body)); } catch (e) {}
    }

    if (isAdd) {
      try {
        let formData = null;

        if (init && init.body instanceof FormData) {
          formData = init.body;
        } else if (init && init.body) {
          formData = new FormData();
          const data = JSON.parse(init.body);
          Object.keys(data).forEach((k) => formData.append(k, data[k]));
        }

        if (!formData) {
          const res = await originalFetch(input, init);
          tryAutoOpenDrawer(url, res);
          return res;
        }

        const variantTitle = (formData.get("properties[_variant_title]") || "").toLowerCase();
        const addingIsUnknown = variantTitle.includes(UNKNOWN_LABEL);
        const isFreeSizer = formData.get("properties[_free_sizer]") === "true";
        const alreadyHasUnknown = localStorage.getItem("tgf_unknown_ring") === "1";

        if (addingIsUnknown && alreadyHasUnknown) {
          showUnknownSizePopup();
          return new Response(JSON.stringify({ blocked: true }), { status: 200 });
        }

        if (addingIsUnknown && !alreadyHasUnknown) {
          localStorage.setItem("tgf_unknown_ring", "1");
        }

        const res = await originalFetch(input, init);
        tryAutoOpenDrawer(url, res);
        return res;

      } catch (err) {
        console.error("Unknown-size guard failed:", err);
        const res = await originalFetch(input, init);
        tryAutoOpenDrawer(url, res);
        return res;
      }
    }

    const response = await originalFetch(input, init);
    tryAutoOpenDrawer(url, response);
    return response;
  };

  async function tryAutoOpenDrawer(url, response) {
    if (!url.includes("/cart/add.js")) return;
    if (!response || !response.ok) return;
    if (!window.TGF) return;

    if (typeof TGF.refreshCartDrawer === "function") {
      await TGF.refreshCartDrawer();
    } else if (typeof TGF.openCartDrawer === "function") {
      TGF.openCartDrawer("add-to-cart");
    }
  }

  function showUnknownSizePopup() {
    let popup = document.getElementById("UnknownSizePopup");

    if (!popup) {
      popup = document.createElement("div");
      popup.id = "UnknownSizePopup";
      popup.innerHTML = `
        <div class="usp-inner">
          <h2>Important</h2>
          <p>You can only purchase <strong>ONE</strong> ring using the 
          <strong>“I don't know my ring size”</strong> option per order.</p>
          <p>If you need to measure multiple fingers, please order additional 
          <a href="${SHOPIFY_ROOT}products/ring-sizer">Ring Sizers</a>.</p>
          <button id="UspClose">Okay</button>
        </div>`;
      document.body.appendChild(popup);
    }

    popup.classList.add("is-visible");

    const closeBtn = document.getElementById("UspClose");
    if (closeBtn) {
      closeBtn.addEventListener(
        "click",
        () => popup.classList.remove("is-visible"),
        { once: true }
      );
    }
  }
})();


/* ============================================================
   2) FORCE CHECKOUT LINKS TO BEHAVE NORMALLY
   ============================================================ */

document.addEventListener(
  "click",
  function (e) {
    const checkoutLink = e.target.closest('a[href*="/checkout"]');
    if (!checkoutLink) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    if (window.TGF?.closeCartDrawer) {
      TGF.closeCartDrawer();
    }

    setTimeout(() => {
      window.location.href = checkoutLink.href;
    }, 150);
  },
  true
);


/* ============================================================
   3) CART DRAWER OPEN/CLOSE + EVENT HANDLER
   ============================================================ */

(function () {
  const rootSel = "#CartDrawerCustom";

  function getRoot() {
    return document.querySelector(rootSel);
  }

  function openDrawer(source = "unknown") {
    const el = getRoot();
    if (!el) return;

    el.classList.add("is-open");
    document.documentElement.classList.add("overflow-hidden");
    preventScroll(true);

    if (typeof gtag === "function") {
      gtag("event", "drawer_open", {
        event_category: "cart",
        event_label: source,
        location: source
      });
    }

    if (typeof fbq === "function") {
      fbq("trackCustom", "DrawerOpen", { source });
    }
  }

  function closeDrawer() {
    const el = getRoot();
    if (!el) return;

    el.classList.remove("is-open");
    document.documentElement.classList.remove("overflow-hidden");
    preventScroll(false);
  }

  function onClick(e) {
    if (e.target.closest("[data-close]")) {
      e.preventDefault();
      closeDrawer();
    }
  }

  function interceptCartClicks() {
    document.addEventListener(
      "click",
      function (e) {
        const a = e.target.closest("a");
        if (!a) return;

        if (a.href.includes("/checkout")) return;

        let isCartLink = false;

        if (
          a.classList.contains("header__icon--cart") ||
          a.classList.contains("header__cart-link")
        ) {
          isCartLink = true;
        } else {
          try {
            const url = new URL(a.href, window.location.origin);
            if (url.pathname.replace(/\/+$/, "") === `${SHOPIFY_ROOT}cart`.replace(/\/+$/, "")) {
              isCartLink = true;
            }
          } catch {}
        }

        if (!isCartLink) return;

        const root = getRoot();
        if (!root) return;

        e.preventDefault();
        openDrawer("header-cart");
      },
      true
    );
  }

  window.TGF = window.TGF || {};
  window.TGF.openCartDrawer = openDrawer;
  window.TGF.closeCartDrawer = closeDrawer;

  interceptCartClicks();

  const root = getRoot();
  if (root) root.addEventListener("click", onClick);
})();


/* ============================================================
   4) SCROLL LOCK FOR CART DRAWER
   ============================================================ */

function preventScroll(active) {
  const body = document.body;

  if (active) {
    const scrollTop = window.scrollY;
    body.dataset.scrollTop = scrollTop;
    body.style.position = "fixed";
    body.style.top = `-${scrollTop}px`;
    body.style.width = "100%";
  } else {
    const scrollTop = parseInt(body.dataset.scrollTop || "0", 10);
    body.style.position = "";
    body.style.top = "";
    body.style.width = "";
    window.scrollTo(0, scrollTop);
  }
}


/* ============================================================
   5) REFRESH CART DRAWER CONTENT
   ============================================================ */

async function refreshCartDrawer() {
  const drawer = document.querySelector("#CartDrawerCustom");
  if (!drawer) return;

  try {
    const url = `${SHOPIFY_ROOT}cart?section_id=cart-drawer-custom`;
    const res = await fetch(url);

    if (!res.ok) throw new Error(res.statusText);

    const html = await res.text();
    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    const newContent = tmp.querySelector("#CartDrawerCustom .cart-drawer__content");
    const oldContent = drawer.querySelector(".cart-drawer__content");

    if (newContent && oldContent) {
      oldContent.innerHTML = newContent.innerHTML;
    }

    const newFooter = tmp.querySelector("#CartDrawerCustom .cart-drawer__footer");
    const oldFooter = drawer.querySelector(".cart-drawer__footer");

    if (newFooter && oldFooter) {
      oldFooter.innerHTML = newFooter.innerHTML;
    }

    
  TGF.openCartDrawer("add-to-cart");

  // Recalculate delivery messaging after the
  // refreshed cart HTML has been inserted.
  if (typeof window.TGF?.updateCartDelivery === "function") {
    await window.TGF.updateCartDelivery();
  }

} catch (err) {
  console.error("Cart drawer refresh failed", err);
}

}

window.TGF = window.TGF || {};
window.TGF.refreshCartDrawer = refreshCartDrawer;


/* ============================================================
   6) CASCADE REMOVALS + UNKNOWN FLAG RESET
   ============================================================ */

document.addEventListener("click", async function (e) {
  const btn = e.target.closest("[data-change]");
  if (!btn) return;

  e.preventDefault();

  const lineKey = btn.dataset.key;
  const qty = parseInt(btn.dataset.qty, 10);
  const parentVariantId = btn.dataset.variantId;

  if (!lineKey || isNaN(qty)) return;

  try {
    const cart = await fetch(`${SHOPIFY_ROOT}cart.js`).then((r) => r.json());

    const updates = {};
    updates[lineKey] = qty;

    if (qty === 0 && parentVariantId) {
      const engravings = cart.items.filter(
        (i) =>
          i.handle === "engraving-service" &&
          i.properties?.["Linked To"] == parentVariantId
      );

      const freeSizers = cart.items.filter(
        (i) =>
          i.properties?._free_sizer == "true" &&
          i.properties?.["Linked To"] == parentVariantId
      );

      [...engravings, ...freeSizers].forEach((item) => {
        updates[item.key] = 0;
      });
    }

    await fetch(`${SHOPIFY_ROOT}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ updates }),
    });

    try {
      const updatedCart = await fetch(`${SHOPIFY_ROOT}cart.js`).then((r) => r.json());

      const hasUnknown = updatedCart.items.some((item) =>
        (item.variant_title || "")
          .toLowerCase()
          .includes("i don't know my ring size")
      );

      if (!hasUnknown) {
        localStorage.removeItem("tgf_unknown_ring");
        console.log("🧹 Cleared tgf_unknown_ring flag");
      }
    } catch (err2) {
      console.warn("Could not verify unknown-size rings after update", err2);
    }

    TGF.refreshCartDrawer();
  } catch (err) {
    console.error("Cart update failed", err);
  }
});


/* ============================================================
   7) CART DRAWER UPSELL — AJAX ADD TO BAG
   ============================================================ */

document.addEventListener("click", async function (event) {
  const button = event.target.closest(
    "#CartDrawerCustom .js-upsell-add"
  );

  if (!button) return;

  event.preventDefault();

  if (button.disabled) return;

  const variantId = Number(button.dataset.variant);

  if (!variantId) {
    console.warn("[TGF Upsell] Missing variant ID");
    return;
  }

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = "Adding...";

  try {
    const response = await fetch(
      `${SHOPIFY_ROOT}cart/add.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      }
    );

    const result = await response.json();

    if (!response.ok || result.blocked) {
      throw new Error(
        result.description || "Unable to add product"
      );
    }

    button.textContent = "Added!";

    // Your existing fetch interceptor already refreshes
    // the cart drawer after successful cart/add.js requests.
    // Only refresh manually if that functionality is missing.
    if (typeof window.TGF?.refreshCartDrawer !== "function") {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          detail: { open: true }
        })
      );
    }

  } catch (error) {
    console.error("[TGF Upsell] Add failed:", error);

    button.textContent = "Try again";

    setTimeout(() => {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 1500);

    return;
  }

  if (button.isConnected) {
    button.disabled = false;
    button.textContent = originalText;
  }
});



/* ============================================================
   7) CART DRAWER UPSELL — AJAX ADD TO BAG
   ============================================================ */

document.addEventListener("click", async function (event) {
  const button = event.target.closest(
    "#CartDrawerCustom .js-upsell-add"
  );

  if (!button) return;

  event.preventDefault();

  if (button.disabled) return;

  const variantId = Number(button.dataset.variant);

  if (!variantId) {
    console.warn("[TGF Upsell] Missing variant ID");
    return;
  }

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = "Adding...";

  try {
    const response = await fetch(
      `${SHOPIFY_ROOT}cart/add.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      }
    );

    const result = await response.json();

    if (!response.ok || result.blocked) {
      throw new Error(
        result.description || "Unable to add product"
      );
    }

    button.textContent = "Added!";

    // Your existing fetch interceptor already refreshes
    // the cart drawer after successful cart/add.js requests.
    // Only refresh manually if that functionality is missing.
    if (typeof window.TGF?.refreshCartDrawer !== "function") {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          detail: { open: true }
        })
      );
    }

  } catch (error) {
    console.error("[TGF Upsell] Add failed:", error);

    button.textContent = "Try again";

    setTimeout(() => {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 1500);

    return;
  }

  if (button.isConnected) {
    button.disabled = false;
    button.textContent = originalText;
  }
});
